<template>
  <template v-if="hasInfo">
    <PropertyDetailsCardInfoItem
      v-for="item in accessibilityItems"
      :key="item.label"
      :label="item.label"
      :value="item.value ? 'Yes' : 'No'"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.accessibility?.accessibilityNotes"
      :label="'Accessibility Notes'"
      :value="property?.accessibility?.accessibilityNotes"
    />
  </template>

  <p v-else>Accessibility not specified</p>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { accessibilityMap } from '../../model/accessibility';
import { PropertyDto } from '../../model/property';
import PropertyDetailsCardInfoItem from './property-details-card/property-details-card-info-item.vue';

const props = defineProps<{
  property: PropertyDto | null | undefined;
}>();

const accessibilityItems = computed(() => {
  return Array.from(accessibilityMap)
    .filter(([key]) => props.property?.accessibility?.[key] !== null)
    .map(([fieldName, label]) => ({
      label,
      value: props.property?.accessibility?.[fieldName],
    }));
});

const hasInfo = computed(() => {
  return props.property?.accessibility?.accessibilityNotes || Boolean(accessibilityItems.value.length);
});
</script>
